export default __webpack_public_path__ + "static/media/BLIZZ.ab3dbbd0.png";